import { Box, Stack, Typography } from "@mui/material";
import { CARD_DATA, CardVariant } from "./CARD_DATA";

export interface KCardProps {
  variant: CardVariant;
  name: string;
  cardNumber: string;
  validUntil: string;
}

export const KCard = ({
  variant,
  name,
  cardNumber,
  validUntil,
}: KCardProps) => {
  const cardData = CARD_DATA[variant];
  return (
    <Box position="relative">
      <Box
        component={"img"}
        src={cardData.image}
        alt="kei card"
        sx={{
          objectFit: "contain",
          width: "100%",
          maxWidth: "30rem",
        }}
      />
      <Stack
        position="absolute"
        bottom={{ xs: "15%", sm: "3rem", md: "2.8rem" }}
        left={{ xs: "10%", sm: "3rem", md: "2.5rem" }}
        gap={{ xs: "0.2rem", md: "0.8rem" }}
      >
        <Typography
          color="white"
          fontWeight="700"
          fontSize={{ xs: "1rem", md: "1.2rem" }}
        >
          {cardNumber}
        </Typography>

        <Typography color="white" fontWeight="700" fontSize="0.8rem">
          {name} &nbsp; {validUntil}
        </Typography>
      </Stack>
    </Box>
  );
};
